import React from 'react';
import { ShowIf } from 'components/utils';
import moment from 'moment';
import {Text, TextMessage} from 'components/tt-forms/common';

class KetQuaXuLyDon extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state ={
      data: this.props.dataGiaiQuyet.thongTinGiaiQuyetDonInfo
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      data: nextProps.dataGiaiQuyet.thongTinGiaiQuyetDonInfo
    })
  }

  render() {
    let lb1 = this.props.donInfo && this.props.donInfo.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' ? 'Đơn vị xác minh đề xuất:' : 'Đơn vị TTXM:';
    return (
      <section className="wrap-block">
        <ShowIf condition={!this.props.status}>
          <h2 className="title-14 mb15 txt-upper txt-blue">Kết quả xử lý đơn</h2>
          <div className="row pl10 pr10">
            <div className='col-100 no-gutter'>
              <Text label="Nhóm thẩm quyền giải quyết:" className="col-25" value={this.props.thamQuyenGiaiQuyet || ''}/>
              <Text label="Phòng ban giải quyết:" className="col-25" value={this.state.data && this.state.data.phongBanGiaiQuyetKetQuaXLDInfo ? this.state.data.phongBanGiaiQuyetKetQuaXLDInfo.ten : ''}/>
              <Text red={true} label="Hạn giải quyết:" className="col-25" value={this.state.data && this.state.data.ngayHetHanGiaiQuyet ? moment(this.state.data.ngayHetHanGiaiQuyet).format('DD/MM/YYYY') : ''}/>
            </div>
            <div className='col-100 no-gutter'>
              <Text label="Quy trình giải quyết:" className="col-25" value={this.state.data && this.state.data.huongThuLyGiaiQuyetInfo ? this.state.data.huongThuLyGiaiQuyetInfo.text : ''}/>
              <ShowIf condition={this.state.data && this.state.data.huongThuLyGiaiQuyet == 'GIAO_TTXM'}>
                <div>
                  <Text label={lb1} className="col-25" value={this.state.data && this.state.data.donViThamTraXacMinhInfo ? this.state.data.donViThamTraXacMinhInfo.ten : ''}/>
                  <Text red={true} label="Thời gian báo cáo kết quả:" className="col-25 mb10" value={this.state.data && this.state.data.ngayHetHanTTXM ? moment(this.state.data.ngayHetHanTTXM).format('DD/MM/YYYY') : ''}/>
                </div>
              </ShowIf>
            </div>
            <TextMessage label="Ý kiến xử lý:" className="col-100" value={this.props.yKienXuLy ? this.props.yKienXuLy : ''}/>
          </div>
        </ShowIf>
      </section>
    );
  }
}

KetQuaXuLyDon.defaultProps = {
  dataGiaiQuyet: {
    thongTinGiaiQuyetDonInfo: {}
  },
  thamQuyenGiaiQuyet: '',
  phongBanGiaiQuyet: '',
  yKienXuLy: '',
  hideBorder: false
}

export default KetQuaXuLyDon;


// WEBPACK FOOTER //
// ./src/components/modules/giai-quyet-don/subView/KetQuaXuLyDon.jsx